export enum GroupLearningPathModuleFlagEnum {
  Close = 0,
  OpenTeacher,
  OpenStudent,
  Validate,
}

export let isGroupLearningPathModuleFlag = (
  variable: unknown
): variable is GroupLearningPathModuleFlagEnum => {
  return (
    variable !== null &&
    variable !== undefined &&
    typeof variable === "number" &&
    variable in GroupLearningPathModuleFlagEnum
  );
};
